import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_URL, token } from "./config";

const Topnav = ({ handleSearch, title, toggleSidebar }) => {
    const [name, setName] = useState('');
    const [surname, setSurname] = useState('');
    const [email, setEmail] = useState('');
    const [search, setSearch] = useState("");
    const [isSearchVisible, setIsSearchVisible] = useState(false); // State for search box visibility

    const navigate = useNavigate();

    useEffect(() => {
        if (localStorage.getItem('user') === null) {
            navigate('/');
        } else {
            const storedUser = localStorage.getItem('user');
            const user = JSON.parse(storedUser);
            setName(user.name);
            setSurname(user.Surname);
            setEmail(user.email);
            localStorage.setItem('userId', user.user_id);
        }
        if (sessionStorage.getItem('token') === null) {
            navigate('/');
        }
    }, [navigate]);

    useEffect(() => {
        sendData();
    }, [search]);

    const sendData = () => {
        if (handleSearch) {
            handleSearch(search);
        }
    };

    const toggleSearch = () => {
        setIsSearchVisible(!isSearchVisible); // Toggle search visibility
    };

    document.addEventListener(
        "contextmenu", function(e) {
            e.preventDefault();
        }, false
    );

    if (!token()) {
        window.location.href = '/';
    }

    useEffect(() => {
            const fetchColleges = async () => {
                try {
                    const response = await fetch(`${API_URL}/colleges`, {
                        method: 'GET',
                        headers: {
                            'Authorization': `Bearer ${token()}`
                        }
                    });
                    if (response.status === 403) {
                        navigate('/');
                    }
                } catch (error) {
                    console.error("Error fetching colleges:", error);
                }
            };
        fetchColleges();
    }, []);


    return (
        <>
            {/* <!-- Topbar --> */}
            <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">

                {/* <!-- Sidebar Toggle (Topbar) --> */}
                <button id="sidebarToggleTop"
                    className="btn btn-link d-md-none rounded-circle mr-3"
                    onClick={toggleSidebar}
                >
                    <i className="fa fa-bars"></i>
                </button>

                {/* <!-- Topbar Search --> */}
                {!title && (
                    <>
                        <form
                            className={`form-inline mr-auto ml-md-3 my-2 my-md-0 mw-100 navbar-search ${isSearchVisible ? '' : 'd-none d-sm-inline-block'}`}>
                            <div className="input-group">
                                <input type="text" className="form-control bg-light border-0 small"
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                    placeholder="Search for..."
                                    aria-label="Search" aria-describedby="basic-addon2" />
                                <div className="input-group-append">
                                    <button className="btn btn-success" type="button">
                                        <i className="fas fa-search fa-sm"></i>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </>
                )}

                {title && (
                    <>
                        <h4 className="h4 mb-2 text-gray-800" style={{ textAlign: 'left' }}> &nbsp; {title}</h4>
                    </>
                )}

                {/* <!-- Topbar Navbar --> */}
                <ul className="navbar-nav ml-auto">

                    {/* <!-- Nav Item - Search Dropdown (Visible Only XS) --> */}
                    <li className="nav-item dropdown no-arrow d-sm-none">
                        <button className="nav-link dropdown-toggle" type="button"
                            id="searchDropdown" onClick={toggleSearch}>
                            <i className="fas fa-search fa-fw"></i>
                        </button>
                        {/* <!-- Dropdown - Messages --> */}
                        {isSearchVisible && (
                            <div className="dropdown-menu dropdown-menu-right p-3 shadow animated--grow-in"
                                aria-labelledby="searchDropdown">
                                <form className="form-inline mr-auto w-100 navbar-search">
                                    <div className="input-group">
                                        <input type="text" className="form-control bg-light border-0 small"
                                            placeholder="Search for..." aria-label="Search"
                                            aria-describedby="basic-addon2"
                                            value={search}
                                            onChange={(e) => setSearch(e.target.value)} />
                                        <div className="input-group-append">
                                            <button className="btn btn-primary" type="button">
                                                <i className="fas fa-search fa-sm"></i>
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        )}
                    </li>

                    <div className="topbar-divider d-none d-sm-block"></div>

                    {/* <!-- Nav Item - User Information --> */}
                    <li className="nav-item dropdown no-arrow">
                        <button className="nav-link dropdown-toggle" type="button"
                            id="userDropdown"
                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <img className="img-profile rounded-circle mr-2"
                                src="img/undraw_profile.svg" alt="img" />
                            <div style={{ textAlign: 'left' }}>
                                <span className="mr-2 d-none d-lg-inline text-gray-600 small">{name} {surname} <br /> {email}</span>
                            </div>
                        </button>
                    </li>

                </ul>
            </nav>
            {/* <!-- End of Topbar --> */}
        </>
    );
}

export default Topnav;

